let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fQwnh")).then(() => parcelRequire('8Xpvo'));